<!-- app页面——个人文档 -->
<template>
  <div class="personDocH5">
    <van-nav-bar title="个人文档" left-arrow @click-left="toBack" />
    <div class="content">
      <div v-for="(item, index) in authDocList" :key="index" class="Doc" @click="toPath(item)">
        <van-image class="Doc_logo" fit="contain" :src="getIcon(item)" />
        <span class="Doc_name">{{ item.name }}</span>
        <van-icon name="arrow" class="rightIcon" />
      </div>
      <div v-if="!authDocList.length" class="empty">暂无权限</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenuList } from "@/CommonDP/utils/tree";

export default {
  components: {},
  data() {
    return {
      myDoc: require("../assets/personDocH5/myDoc.png"), // 图标
      myShare: require("../assets/personDocH5/myShare.png"),
      myCollection: require("../assets/personDocH5/myCollection.png"),
      recycleBin: require("../assets/personDocH5/recycleBin.png")
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes // 当前用户权限
    }),
    // 用户有权限的文档目录
    authDocList() {
      const doc = this.authRoutes.find(({ permissionKey }) => permissionKey === "doc");
      const docList = doc ? this.menuList([doc]) : []; // 知识菜单列表
      const persondoc = docList.find(({ permissionKey }) => permissionKey === "persondoc");
      const personList = persondoc ? persondoc.sub : []; // 个人文档菜单列表
      return personList;
    }
  },
  mounted() {},
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },
    // 对象转菜单列表
    menuList(array) {
      const list = getMenuList(array) || [];
      if (list.length > 0) {
        if (list[0].sub && list[0].sub.length > 0) {
          list[0].sub = list[0].sub.filter(({ resourceType }) => resourceType === 0);
          return list[0].sub;
        }
      }
      return [];
    },

    // 模块图标
    getIcon(item) {
      const { path } = item || {};
      let icon = "";
      switch (path) {
        case "/mydoc":
          icon = this.myDoc;
          break;
        case "/myshare":
          icon = this.myShare;
          break;
        case "/mycollection":
          icon = this.myCollection;
          break;
        case "/myrecycle":
          icon = this.recycleBin;
          break;
      }
      return icon;
    },
    // 跳转路径
    toPath(item) {
      const { path } = item || {};
      switch (path) {
        case "/mydoc":
          this.$router.push("/personDocH5/myDocH5");
          break;
        case "/myshare":
          this.$router.push("/personDocH5/myShareH5");
          break;
        case "/mycollection":
          this.$router.push("/personDocH5/myCollectionH5");
          break;
        case "/myrecycle":
          this.$router.push("/personDocH5/myRecycleH5");
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.personDocH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
    .empty {
      width: 100%;
      height: calc(100% - 66px);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--info-color)9;
      font-size: 16px;
    }
  }
}

.Doc {
  width: 100vw;
  height: 70px;
  padding: 0 3vw;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;

  .Doc_logo {
    width: 42px;
    height: 42px;
    padding: 5px;
    margin-bottom: 2px;
  }

  .Doc_name {
    width: calc(100% - 65px);
    padding-left: 5px;
    line-height: 40px;
    font-size: 16px;
  }

  .rightIcon {
    font-size: 14px;
    color: #6f6f6f;
  }
}
</style>
